import { useLoaderData } from 'react-router';
import { MobileIdDetailsContent } from '../../../../../components/MobileId/MobileIdDetails.js';
import type { Contract } from '../../../../../generated/api/contract';

export const MobileIdDetailsPath = () => {
  const mobileIdContract = useLoaderData() as Contract;
  return <MobileIdDetailsContent mobileIdContract={mobileIdContract} />;
};
